<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/useAuthStore'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const props = defineProps<{
  disable?: boolean
}>()

const { umsokn, onLoaded } = useUmsokn()
const authStore = useAuthStore()

const rules = {
  umsokn: {
    confirmTaxes: { sameAs: sameAs(true) }
  }
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})

onLoaded(async () => {
  const user = await authStore.getAuthUser()
  if (user && umsokn.value) {
    umsokn.value.name = user.name
    umsokn.value.ssn = user.username
  }
})
</script>

<template>
  <div v-if="umsokn">
      <div class="forms__header">{{ $t('ororku_umsokn_step5_header') }}</div>

      <v-row>
        <v-col>
          <p>{{ $t('ororku_umsokn_step5_paragraph') }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-checkbox
            v-model="umsokn.confirmTaxes"
            :readonly="props.disable"
            :label="$t('ororku_umsokn_step5_skilmalar')"
            :error="v$.umsokn.confirmTaxes.$error"
            :error-messages="v$.umsokn.confirmTaxes.$error ? [$t('ororku_umsokn_step5_skilmalar_error')] : []"
          />
        </v-col>
      </v-row>

  </div>
</template>
